<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId")
      a.fa-stack.fa-lg(slot="trigger" v-if="segment == null" )
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      a(v-else, slot="trigger") Edit
      h2(v-if="segment == null") Create new segment
      .row
        .column
          label Name
            input(type="text", v-model="body.name")
          label Picture
            input(type="text", disabled, v-model="body.picture")
          kepler-file-upload(@sel="handleFileSelector", selectedPrefix="segments", selectedVisibility="public")
        .column
          label Hint
            input(type="text", v-model="body.hint")
      .row.column
        label Description
        Editor(v-model="body.description" )
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel
</template>

<script>

import ModalReveal from "../../foundation/ModalReveal";
import LoadingSpinner from "../../LoadingSpinner";
import ActionButton from "../ActionButton";
import Editor from "../Editor";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import KeplerFileUpload from "../../KeplerFileUpload";

export default {
  name: 'SegmentReveal',
  components: {
    KeplerFileUpload,
    Editor,
    ActionButton,
    LoadingSpinner,
    ModalReveal


  },
  data() {
    return {
      body: {
        name: null,
        description: "",
        hint: null,
        picture: null,

      },

    }
  },
  created() {
    if (this.segment !== null) {
      for (let key in this.segment) {
        switch (key) {
          case 'segment_rates':
            this.body[key] = this.segment[key].map((item) => {
              return item.id
            })
            break
          default:
            this.body[key] = this.segment[key]
        }
      }
    }
  },
  methods: {
    save() {
      if (this.segment !== null) {
        return KeplerBackofficeSdk.segments.select(this.segment.id).edit(this.body, () => {
          this.$emit('itemUpdated')
          this.$refs[this.componentId].close()
        })
      }
      return KeplerBackofficeSdk.segments.make(this.body, () => {
        this.$emit('itemUpdated')
        this.$refs[this.componentId].close()
      })
    },
    handleFileSelector(path) {
      this.body.picture = path
    },
  },
  computed: {
    componentId() {
      const item = this.item !== null ? this.item : this.segment
      const id = item == null ? this._uuid : item.id
      return `segmentReveal-${id}`
    },

  },
  props: {
    item: {
      type: Object,
      default: null
    },
    segment: {
      type: Object,
      default: null
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SegmentReveal.vue?2975a6ce